import { detectBrowser } from '../../../utils/detectBrowser';
import CloseCross from '../../atoms/icons/CloseCross';
import LocationStoreLocatorStroke from '../../atoms/icons/LocationStoreLocatorStroke';
import styles from './InfoBox.module.scss';
import './InfoBox.global.scss';
import clsx from 'clsx';
import React, { useRef, FC } from 'react';
import { useHistory } from 'react-router-dom';
import { handleize } from '@srcDS/utils/helpers';
import { Department } from '../../atoms/icons';

type InfoBoxProps = {
  storeName: string;
  address1: string;
  address2?: string;
  state: string;
  postcode: string;
  city: string;
  keyId: string;
  storeDescription?: string;
  onClose: () => void;
  'department-list'?: string[];
};

export const InfoBox: FC<InfoBoxProps> = (props) => {
  const browserName = detectBrowser();
  const popupRef = useRef<HTMLDivElement>();
  const history = useHistory();
  const { storeName, address1, address2, state, postcode, city, keyId, storeDescription, onClose } = props;

  const address = `${address1} ${address2 && address2 + ','} ${city && city + ','} ${state} ${postcode}`;

  return (
    <div ref={popupRef} className={styles.infoBox}>
      <div className={clsx(styles.infoBoxCloseBtn, styles[browserName])} onClick={onClose}>
        <CloseCross />
      </div>
      <div className={styles.infoBoxTitle}>{storeName}</div>
      <div className={styles.infoBoxDesc}>{storeDescription}</div>
      {address && (
        <div className={styles.addressWrap}>
          <LocationStoreLocatorStroke width={26} height={26} />
          <span>{address}</span>
        </div>
      )}
      {props?.['department-list']?.length > 0 && (
        <div className={styles.departmentsBlock}>
          <Department />
          <p className={styles.addressWrap}>
            <span>Department: {props?.['department-list']?.join(', ')}</span>
          </p>
        </div>
      )}
      <p
        onClick={() => {
          history &&
            history.push(
              `/store-locator/store-details?state=${state}&suburb=${city}&store=${handleize(storeName)}&id=${keyId}`,
            );
        }}
        className={styles.infoBoxLink}
      >
        View Store Information
      </p>
    </div>
  );
};
